var map = {
	"./cs.json": [
		68241,
		[
			"apps_pap-app_src_assets_i18n_cs_json"
		]
	],
	"./cs_backup_11-2022.json": [
		91904,
		[
			"apps_pap-app_src_assets_i18n_cs_backup_11-2022_json"
		]
	],
	"./en.json": [
		51696,
		[
			"apps_pap-app_src_assets_i18n_en_json"
		]
	],
	"./lv.json": [
		53097,
		[
			"apps_pap-app_src_assets_i18n_lv_json"
		]
	],
	"./tr.json": [
		83061,
		[
			"apps_pap-app_src_assets_i18n_tr_json"
		]
	],
	"./tr_backup_1-2023.json": [
		33414,
		[
			"apps_pap-app_src_assets_i18n_tr_backup_1-2023_json"
		]
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 67805;
module.exports = webpackAsyncContext;